import { createContext, useContext } from 'react';

/**
 * True for everything rendered inside the printed report.
 *
 * Printing takes the DOM exactly as it stands at that instant. A chart that is
 * still playing its entry animation therefore prints half-drawn — a donut with
 * a wedge missing, a line that stops in mid-air — and the report is off-screen
 * while the browser lays the pages out, so the animation often has not even
 * started. Inside this scope the charts skip the animation and draw finished.
 */
export const PrintScopeContext = createContext(false);

/** `isAnimationActive` for a chart series: on screen yes, in the report no. */
export function useChartAnimation(): boolean {
  return !useContext(PrintScopeContext);
}
